"use client";

import * as React from "react";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type SectionLanguage = "en" | "it";
export default function RegistryIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [language, setLanguage] = React.useState<SectionLanguage>("en");
  React.useEffect(() => {
    const savedLanguage = localStorage.getItem("site-language");
    if (savedLanguage === "en" || savedLanguage === "it") {
      setLanguage(savedLanguage);
    }
  }, []);
  React.useEffect(() => {
    const handleStorageChange = () => {
      const savedLanguage = localStorage.getItem("site-language");
      if (savedLanguage === "en" || savedLanguage === "it") {
        setLanguage(savedLanguage);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("focus", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("focus", handleStorageChange);
    };
  }, []);
  const t = {
    en: {
      title: "Registry",
      comingSoon: "Coming Soon",
      description: "Celebrating our wedding in Rome with our closest family and friends is truly the greatest gift we could ask for. We are currently finalizing our registry and will share details here soon for those who wish to contribute to our future.",
      button: "View Registry",
      hover: "Coming Soon"
    },
    it: {
      title: "Lista Nozze",
      comingSoon: "Prossimamente",
      description: "Celebrare il nostro matrimonio a Roma con la nostra famiglia e i nostri amici più cari è davvero il regalo più grande che potessimo desiderare. Stiamo attualmente completando la nostra lista nozze e condivideremo presto qui i dettagli per chi desidera contribuire al nostro futuro.",
      button: "Vedi Lista Nozze",
      hover: "Prossimamente"
    }
  }[language];
  return <section id="registry-introduction" className="bg-background py-24 md:py-32 px-6 overflow-hidden flex flex-col items-center justify-center">
      <div ref={ref} className={`max-w-3xl mx-auto text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground tracking-tight mb-6">
          {t.title}
        </h2>

        <p className="font-serif italic text-lg md:text-xl text-muted-foreground mb-6">
          {t.comingSoon}
        </p>

        <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed mb-10 max-w-2xl">
          {t.description}
        </p>

        <Separator className="w-24 bg-primary h-[1px] mb-10" />

        <div className="flex flex-col sm:flex-row gap-4 mt-4">
          <div className="group relative">
            <Button disabled className="rounded-none px-8 py-6 text-[12px] uppercase tracking-[3px] font-sans border border-primary bg-transparent text-foreground opacity-60 cursor-not-allowed">
              {t.button}
            </Button>

            <span className="absolute left-1/2 -translate-x-1/2 top-full mt-2 text-[10px] tracking-[2px] uppercase text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              {t.hover}
            </span>
          </div>
        </div>
      </div>
    </section>;
}